// ============================================================================
// Configuration funnel (VSL Loom + cal.com + Thank You)
//   Réglable via variables d'env NEXT_PUBLIC_* (inlinées au build).
//   Les valeurs par défaut correspondent au funnel Bootcamp Manager Augmenté.
// ============================================================================

const env = (key: string, fallback: string) => {
  const v = process.env[key];
  return v && v.trim() ? v.trim() : fallback;
};

// --- VSL (Loom) ------------------------------------------------------------
// ID = segment après /share/ ou /embed/ dans l'URL Loom.
export const LOOM_ID = env(
  "NEXT_PUBLIC_LOOM_ID",
  "d39b8f4175604574a295390988c80da7"
);

// Miniature animée (GIF) affichée comme vignette de la vidéo sur la LP.
// L'URL contient un hash de session propre à la vidéo (non dérivable du seul ID).
export const LOOM_THUMBNAIL = env(
  "NEXT_PUBLIC_LOOM_THUMBNAIL",
  "https://cdn.loom.com/sessions/thumbnails/d39b8f4175604574a295390988c80da7-0752638bf5b61c92-full-play.gif"
);

// --- VSL (vturb / converteai smartplayer) ----------------------------------
// Lecteur principal de la VSL (remplace Loom). IDs extraits de l'embed vturb :
//   scripts.converteai.net/{ACCOUNT_ID}/players/{PLAYER_ID}/v4/player.js
// Non secrets → fallbacks suffisants (aucun build arg requis pour les défauts ;
// n'ajouter au Dockerfile/compose que si l'on veut surcharger par env).
export const VTURB_ACCOUNT_ID = env(
  "NEXT_PUBLIC_VTURB_ACCOUNT_ID",
  "0935f08d-c2d9-4072-9fcc-b5cdf8a230ac"
);
export const VTURB_PLAYER_ID = env(
  "NEXT_PUBLIC_VTURB_PLAYER_ID",
  "6a5390f27ffebb53ceb98f08"
);

// --- cal.com ---------------------------------------------------------------
export const CAL_NAMESPACE = env(
  "NEXT_PUBLIC_CAL_NAMESPACE",
  "candidature-bootcamp-manager-ia"
);
export const CAL_LINK = env(
  "NEXT_PUBLIC_CAL_LINK",
  "akpenou/candidature-bootcamp-manager-ia"
);
export const CAL_BRAND_COLOR = env("NEXT_PUBLIC_CAL_BRAND_COLOR", "#2c5f1a");

// --- Thank You -------------------------------------------------------------
export const ORGANIZER_NAME = env(
  "NEXT_PUBLIC_ORGANIZER_NAME",
  "L’équipe du Bootcamp Manager Augmenté"
);
